/* global ViewController, WebView */
var dinvoiceShareController = new ViewController({
    directory : "views/public",
    name: "dinvoiceShare",
    container: "main",
    route: "dinvoice-share"
}) ;

dinvoiceShareController.prepareDataOnEnter = function(token, callback){
    this.api.public.getSharedDinvoice(token, function(err, invoice){
        if(err){
            if(err === "EXPIRED"){
                return callback(null, { expired: true }) ;
            }
            if(err === "NOT_FOUND"){
                return callback(null, { notfound: true }) ;
            }
            if(err === "WRONG_PASSWORD"){
                return callback(null, { wrongpassword: true }) ;
            }
            return callback(err) ;
        }
        invoice.hasCustomBg = true ;
        invoice.token = token ;
        callback(null, invoice) ;
    }.bind(this)) ;
};

dinvoiceShareController.onDownload = function(){
    if(!this.data.share_with_password){
        this.view.longTask(function(done){
            this.api.public.downloadSharedDinvoice(this.data.token, done) ;
        }.bind(this)) ;
    }else{
        var viewChange = new WebView("views/public", "docSharePasswordPopup") ;
        viewChange.openInPopup({
            title: ''
        })  ;
        viewChange.on("validate", function(){
            var passData = viewChange.getData() ;
            viewChange.close() ;
            this.view.longTask(function(done){
                this.api.public.checkPassSharedDinvoice(this.data.token, passData.share_password, function(err){
                    if(err){
                        if(err === "WRONG_PASSWORD"){
                            return done(WebView.tr("docShare.wrongPassword")) ;
                        }
                        return done(err) ;
                    }
                    this.api.public.downloadSharedDinvoice(this.data.token, passData.share_password, function(err){
                        if(err){ return done(err) ; }
                        done() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }
} ;

module.exports = dinvoiceShareController ;
